import { render } from "./AdminInvoiceConfig.vue?vue&type=template&id=73e92f5b&scoped=true"
import script from "./AdminInvoiceConfig.vue?vue&type=script&lang=js"
export * from "./AdminInvoiceConfig.vue?vue&type=script&lang=js"

import "./AdminInvoiceConfig.vue?vue&type=style&index=0&id=73e92f5b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73e92f5b"]])

export default __exports__